import { Avatar, Col, Dropdown, Modal, Row, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { CaretDownOutlined, UserOutlined } from "@ant-design/icons";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './index.css'
import ChangePassword from '../../Pages/changePassword';
import useAuthStore from '../../Store/authStore';
import useAuth from '../../Config/hooks/Apis/useAuth';
import { resolveMediaUrl } from '../../Config/api/baseUrl';

const HeaderDropDown = ({ showDrawer, setShowDrawer, drawer = true }) => {

    const navigate = useNavigate();
    const location = useLocation();
    const { user, isAuthenticated } = useAuthStore();
    const { logout } = useAuth();

    const [itemIsActive, setItemIsActive] = useState('');
    const [changePasswordModal, setChangePasswordModal] = useState(false);

    const navItemNavigator = (key, item) => {
        let selectedItem = item?.replaceAll(' ', '');
        if (item) {
            navigate(`/${selectedItem}`);
            item == 'Change Password' && setChangePasswordModal(true)
        }

        setItemIsActive(item);
        if (drawer) setShowDrawer(false);
    }


    const items = [
        {
            key: 1,
            title: 'Profile',
            label: (
                <Link className="flex items-center gap-4">
                    <span className={`${itemIsActive == 'Profile' ? 'text-white' : ''}`}>Profile</span>
                </Link>
            ),
            onClick: () => navItemNavigator(1, 'Profile'),
        },
        {
            label: (
                <div className="border-b border-dashed w-full"></div>
            ),
        },
        {
            key: 2,
            title: 'My Order',
            label: (
                <Link className="flex items-center gap-4">
                    <span className={`${itemIsActive == 'My Order' ? 'text-white' : ''}`}>My order</span>
                </Link>
            ),
            onClick: () => navItemNavigator(2, 'My Order'),
        },
        {
            label: (
                <div className="border-b border-dashed w-full"></div>
            ),
        },
        {
            key: 3,
            title: 'Change Password',
            label: (
                <Link className="flex items-center gap-4">
                    <span className={`${itemIsActive == 'Change Password' ? 'text-white' : ''}`}>Change Password</span>
                </Link>
            ),
            onClick: () => navItemNavigator(3, 'Change Password'),
        },
        {
            label: (
                <div className="border-b border-dashed w-full"></div>
            ),
        },
        {
            key: 4,
            title: 'Logout',
            label: (
                <Link className="flex items-center gap-4">
                    <span className={`${itemIsActive == 'Logout' ? 'text-white' : ''}`}>Logout</span>
                </Link>
            ),
            onClick: async () => {
                try {
                    await logout();
                    navigate('/');
                    if (drawer && setShowDrawer) setShowDrawer(false);
                } catch (error) {
                    console.error('Logout error:', error);
                }
            },
        },
    ];


    useEffect(() => {
        if (location.pathname !== '/') {
            let selectedItem = items.find((item) => '/' + item?.title?.replaceAll(' ', '') == location.pathname);
            if (selectedItem) {
                setItemIsActive(selectedItem?.title)
            } else {
                setItemIsActive('')
            }
        }
    }, [location.pathname])

    // Get user image URL
    const getUserImageUrl = () => {
        if (!user?.image) return null;
        
        // If image is already a full URL, return it
        if (user.image.startsWith('http')) {
            return user.image;
        }
        
        return resolveMediaUrl(user.image);
    };

    const userImageUrl = getUserImageUrl();

    return (
        <>
            <Dropdown
                menu={{ items, activeKey: itemIsActive }}
                className="group w-44 h-10 flex items-center justify-between px-3 py-3 cursor-pointer primary-btn primary-btn-color"
            >
                <div className="flex gap-1">
                    <div className="w-10 h-10 flex items-center justify-center">
                        <Avatar 
                            src={userImageUrl}
                            icon={!userImageUrl ? <UserOutlined /> : null}
                            className='flex items-center justify-center' 
                            shape="circle"
                            onError={() => {
                                // Fallback to icon if image fails to load
                                return false;
                            }}
                        />
                    </div>
                    <span className="text-ellipsis truncate">
                        <p className='font-medium text-sm tracking-wider'>{user?.firstName || user?.firstname || user?.name || user?.email || 'User'}</p>
                    </span>
                    <CaretDownOutlined className="" />
                </div>
            </Dropdown>

            {
                changePasswordModal &&
                <Modal
                    open={changePasswordModal}
                    onCancel={() => setChangePasswordModal(false)}
                    width={400}
                    centered
                    footer={false}
                >
                    <Row justify={'center'} className='flex flex-col items-center gap-4 px-4 w-full'>
                        <ChangePassword />
                    </Row>
                </Modal>
            }

        </>
    )
}

export default HeaderDropDown